import PropTypes from 'prop-types'

import { Chip, Box, Button, Typography, Tooltip } from '@mui/material'

import { Plus } from 'phosphor-react'

import useTranslations from '../../../i18n/useTranslations'
import Divider from '../../../ui/components/divider'

import { ReactComponent as Package } from '../../../assets/icons/package.svg'
import { ReactComponent as Weight } from '../../../assets/icons/weight.svg'

import useStyles from './styles'

const PackageForm = ({
  count,
  weight,
  children,
  onAdd,
  showPopup,
  isAddButtonDisabled,
}) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Box>
        <Box mb={2}>{children}</Box>
        <Tooltip disableHoverListener={!showPopup} title={showPopup} arrow placement="bottom" >
          <Box className={classes.alertShippingRestrictions}>
            <Button
              onClick={onAdd}
              disabled={isAddButtonDisabled}
              variant="outlined"
              size="small"
              startIcon={<Plus />}
            >
              {t('action:add-package')}
            </Button>
          </Box>
        </Tooltip>
      </Box>
      <Box>
        <Divider orientation="vertical" className={classes.divider} />
        <Box className={classes.chips}>
          <Chip
            className={count ? 'purple' : ''}
            avatar={<Package />}
            label={
              <>
                {t('noun:total-packages')}{' '}
                {count ? <strong>{count}</strong> : '-'}
              </>
            }
          />
          <Chip
            className={weight ? 'purple' : ''}
            avatar={<Weight />}
            label={
              <>
                {t('noun:reported weight')}{' '}
                {weight ? (
                  <strong>
                    {t('placeholder:kilograms', { number: weight })}
                  </strong>
                ) : (
                  <>{t('placeholder:kilograms', { number: '-' })}</>
                )}
              </>
            }
          />
        </Box>
      </Box>
    </Box>
  )
}

PackageForm.propTypes = {
  count: PropTypes.number.isRequired,
  getWeightText: PropTypes.string,
  showPopup: PropTypes.string,
  weight: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isAddButtonDisabled: PropTypes.bool,
}

export default PackageForm
